import { useContext } from 'react'
import { DataContext } from '../context/DataContext'
import { normalizeRegionName } from '../helpers/addressParser'
import { splitStringIntoTwoParts, transformCart, transformCartTotals } from '../helpers/utils'

export const useMagento = () => {
  const {
    userInfo,
    addressInfo,
    setIsPaying,
    setEcommerceInfo,
    setCartData,
    ecommerceInfo,
    setUserInfo,
    setBillingInfo,
    billingInfo,
    setAddressInfo,
    deliveryInfo
  } = useContext(DataContext)

  const setInitialInformationMagento = message => {
    const { cms, items, totals, currentUrl, totalWeight, customerData } = message
    console.log(' setInitialInformationMagento ~ message:', message)
    if (cms !== undefined && cms !== 'magento') return
    setEcommerceInfo(prevState => {
      return { ...prevState, cms: 'magento', currentUrl, isCompanyAccount: customerData?.isCompanyAccount }
    })

    setCartData(prevState => {
      return {
        ...prevState,
        lines: transformCart(items),
        ...transformCartTotals(totals),
        totalWeight: Math.ceil(totalWeight)
      }
    })

    if (customerData) {
      const { email, firstname, lastname, corporateName, corporateRut, isCompanyAccount, shippingAddress, isValidAddress } = customerData
      const shippingTelephone = shippingAddress?.telephone || ''
      const names = `${firstname} ${lastname}`

      setUserInfo(prevState => {
        return {
          ...prevState,
          email,
          names: names.includes('null') ? '' : names,
          phone: shippingTelephone.length > 9 ? shippingTelephone.slice(shippingTelephone.length - 9) : shippingTelephone
        }
      })

      if (shippingAddress?.street[0]) {
        const aditionalInfo = shippingAddress.custom_attributes.ad_office_house?.value || ''
        setAddressInfo((prevState) => {
          return {
            ...prevState,
            userAddress: shippingAddress.street[0],
            savedAddress: {
              isValidAddress,
              userAddress: shippingAddress.street[0],
              district: shippingAddress.city,
              postcode: shippingAddress.postcode
            },
            aditionalInfo
          }
        })
      }

      if (isCompanyAccount) {
        setBillingInfo((prevState) => {
          return {
            ...prevState,
            corporateName,
            corporateRut
          }
        })
      }
    }
  }

  const iframeLoadedMagento = () => {
    window.parent.postMessage(
      {
        type: 'iframe-mounted',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const removeIframeMagento = () => {
    window.parent.postMessage(
      {
        type: 'remove-iframe',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const magentoClosePinmap = () => {
    window.parent.postMessage(
      {
        type: 'close-iframe',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const redirectToHomeMagento = () => {
    window.parent.postMessage(
      {
        type: 'redirect-to-home',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const submitFormMagento = () => {
    setTimeout(() => {
      window.parent.postMessage(
        {
          type: 'submit-form',
          origin: 'pinflag-checkout-iframe',
          message: true
        },
        '*'
      )
    }, 3000)

    setTimeout(() => setIsPaying(false), 8000)
  }

  const shippingPostMessageMagento = () => {
    if (ecommerceInfo.cms !== undefined && ecommerceInfo.cms !== 'magento') { return }
    const { corporateName, corporateRut } = billingInfo
    const firstname = userInfo.names.substring(0, userInfo.names.indexOf(' '))
    const lastname = userInfo.names.substring(userInfo.names.indexOf(' ') + 1)
    const [corporateNameFirstPart, corporateNameSecondPart] = splitStringIntoTwoParts(corporateName)
    const { aditionalInfo, deliveryType, price, userAddress, district, region, savedAddress, serviceName } = addressInfo

    const serviceIndex = deliveryInfo.services ? deliveryInfo.services.findIndex(service => service.name === serviceName) : 0
    const postcode = `${Math.floor(100000 + Math.random() * 90000)}${serviceIndex}`

    console.log('saved address', savedAddress)
    console.log('address info', addressInfo)
    console.log('hasNewAddress', savedAddress
      ? !savedAddress.isValidAddress || savedAddress.userAddress + savedAddress.district + savedAddress.postcode !== userAddress + district + `${price}`
      : false)

    window.parent.postMessage(
      {
        type: 'set-form-data',
        origin: 'pinflag-checkout-iframe',
        message: {
          'custom_attributes[pinflag_address_comment]': aditionalInfo,
          'custom_attributes[pinflag_shipping_method]': deliveryType,
          'custom_attributes[pinflag_shipping_price]': `${price}`,
          'custom_attributes[pinflag_save_customer_info]': userInfo.saveData,
          'custom_attributes[rut]': !ecommerceInfo.isCompanyAccount && corporateName ? corporateRut : userInfo.rut,
          'street[0]': userAddress,
          postcode,
          city_id: district,
          firstname: !ecommerceInfo.isCompanyAccount && corporateName ? corporateNameFirstPart : firstname,
          lastname: !ecommerceInfo.isCompanyAccount && corporateName ? corporateNameSecondPart : lastname,
          region_id: normalizeRegionName(region),
          telephone: userInfo.phone,
          username: userInfo.email,
          isBillingData: !!corporateName,
          hasNewAddress: savedAddress
            ? !savedAddress.isValidAddress || savedAddress.userAddress + savedAddress.district + savedAddress.postcode !== userAddress + district + `${price}`
            : false
        }
      },
      '*'
    )

    // setTimeout(() => {
    //   window.parent.postMessage(
    //     {
    //       type: 'set-form-data',
    //       origin: 'pinflag-checkout-iframe',
    //       message: {
    //         'custom_attributes[pinflag_address_comment]': aditionalInfo,
    //         'custom_attributes[pinflag_shipping_method]': deliveryType,
    //         'custom_attributes[pinflag_shipping_price]': `${price}`,
    //         'custom_attributes[pinflag_save_customer_info]': userInfo.saveData,
    //         'custom_attributes[rut]': !ecommerceInfo.isCompanyAccount && corporateName ? corporateRut : userInfo.rut,
    //         'street[0]': userAddress,
    //         postcode,
    //         city_id: district,
    //         firstname: !ecommerceInfo.isCompanyAccount && corporateName ? corporateNameFirstPart : firstname,
    //         lastname: !ecommerceInfo.isCompanyAccount && corporateName ? corporateNameSecondPart : lastname,
    //         region_id: normalizeRegionName(region),
    //         telephone: userInfo.phone,
    //         username: userInfo.email,
    //         isBillingData: !!corporateName,
    //         hasNewAddress: savedAddress
    //           ? !savedAddress.isValidAddress || savedAddress.userAddress + savedAddress.district + savedAddress.postcode !== userAddress + district + `${price}`
    //           : false
    //       }
    //     },
    //     '*'
    //   )
    // }, 1000)
  }

  return {
    setInitialInformationMagento,
    iframeLoadedMagento,
    removeIframeMagento,
    shippingPostMessageMagento,
    submitFormMagento,
    redirectToHomeMagento,
    magentoClosePinmap
  }
}
